class QuantitySelector extends HTMLElement {
  constructor() {
    super();
    this.form = document.getElementById(this.dataset.formId);
    if (!this.form) return;

    this.quantityInput = this.form.querySelector('[name="quantity"]');
    if (!this.quantityInput) return;

    this.selectorType = this.dataset.selectorType;

    if (this.selectorType === 'buttons') {
      this.querySelectorAll('.quantity-btn').forEach(button => {
        button.addEventListener('click', this.onButtonClick.bind(this));
      });
    } else {
      this.querySelector('.quantity-select').addEventListener('change', this.onSelectChange.bind(this));
    }

    this.addEventListener('change', this.onQuantityChange);

    this.init();
  }

  init() {
    const initialQuantity = this.dataset.defaultQuantity || this.quantityInput.value;
    this.quantityInput.value = initialQuantity;
    this.updatePrice(initialQuantity);
  }

  onButtonClick(event) {
    event.preventDefault();
    const button = event.currentTarget;
    this.querySelectorAll('.quantity-btn').forEach(btn => btn.classList.remove('active'));
    button.classList.add('active');
    this.quantityInput.value = button.dataset.quantity;
    this.dispatchEvent(new Event('change', { bubbles: true }));
  }

  onSelectChange(event) {
    this.quantityInput.value = event.currentTarget.value;
    this.dispatchEvent(new Event('change', { bubbles: true }));
  }

  onQuantityChange() {
    this.updatePrice(this.quantityInput.value);
  }

  updatePrice(quantity) {
    const enableDynamicPricing = this.dataset.enableDynamicPricing === 'true';
    if (!enableDynamicPricing) return;

    const basePrice = parseFloat(this.dataset.basePrice);
    if (isNaN(basePrice)) return;

    const newPrice = (basePrice * quantity).toFixed(2);
    
    // The theme's money format can be passed in to format the price correctly.
    // Example format: ${{amount}}
    const moneyFormat = this.dataset.moneyFormat || '${{amount}}';
    const formattedPrice = moneyFormat.replace('{{amount}}', newPrice);
    const formattedPriceWithDash = formattedPrice;

    const priceContainer = document.querySelector(`#price-${this.dataset.sectionId}`);
    if (priceContainer) {
      const priceElements = priceContainer.querySelectorAll('.price-item--regular');
      priceElements.forEach(el => el.textContent = formattedPrice);
    }
    
    const dynamicPriceElement = this.form.querySelector(`#dynamic-price-${this.dataset.sectionId}`);
    if (dynamicPriceElement) {
      dynamicPriceElement.textContent = formattedPriceWithDash;
    }
  }
}

customElements.define('quantity-selector', QuantitySelector); 